import GatewayService from '../GatewayService.js';
var storage = new GatewayService('user-note-service');

var fetchNote = function fetchNote(userKey, noteContainerKey) {
  return storage.get("notes/".concat(userKey, "/").concat(noteContainerKey));
};

var writeNote = function writeNote(userKey, noteContainerKey, noteText) {
  return storage.post("notes/".concat(userKey, "/").concat(noteContainerKey), noteText, {
    headers: {
      'Content-Type': 'text/plain'
    }
  });
};

var deleteNote = function deleteNote(userKey, noteContainerKey) {
  return storage["delete"]("notes/".concat(userKey, "/").concat(noteContainerKey));
};

export default {
  fetchNote: fetchNote,
  writeNote: writeNote,
  deleteNote: deleteNote
};